import React from 'react';
interface FieldGridProps {
  children: ReactNode;
  columns?: 1 | 2;
}
export function FieldGrid({
  children,
  columns = 2
}: FieldGridProps) {
  return <div className={`grid gap-4 ${columns === 2 ? 'md:grid-cols-2' : 'grid-cols-1'}`} data-id="element-21">
      {children}
    </div>;
}